
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/mobile-development",
      function () {
        return require("private-next-pages/services/mobile-development.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/mobile-development"])
      });
    }
  